// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    box-sizing: border-box;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    text-decoration: none!important;
    color: #0B093B;
  }
  a:hover {
    color: #72246c;
  }
  input:-webkit-autofill { /* Change the color to your own background color */
    box-shadow: transparent;
    -webkit-text-fill-color: #fff;
  }
  body {
    background: #fff;
    color: #0B093B;
    font-family: 'Khula', sans-serif;
    overflow-x: hidden;
    font-size: 16px;
    font-weight: 400;
  }
  .container {
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
    padding: 0px 30px;
  }
  @media only screen and (max-width: 859px) {
    .container {
      max-width: 100%;
      width: 100%;
      margin: 0;
      padding: 0 5px;
    }
  }
  .regular {
    font-weight: 400!important;
  }
  .semiBold {
    font-weight: 600!important;
  }
  .extraBold {
    font-weight: 800!important;
  }

  /* HELLPERS */
  .textCenter {
    text-align: center
  }
  .animate {
    transition: 0.3s ease;
  }
  .pointer {
    cursor: pointer;
  }
  .relative {
    position: relative;
  }
  .textCenter {
    text-align: center;
  }
  .textLeft {
    text-align: left;
  }
  .textRight {
    text-align: right;
  }
  .x100 {
    width: 100%;
  }
  .active {
    border-bottom: 2px solid #72246c;
    color: #72246c;
  }
  .tag {
    padding: 5px 10px;
    margin: 10px 0;
  }
  .shadow {
    box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; 
    -webkit-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; 
    -moz-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; 
  }
  /* FLEXBOX */
  .flex {
    display: flex;
  }
  .flexSpaceCenter {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flexNullCenter {
    display: flex;
    align-items: center;
  }
  .flexColumn {
    flex-direction: column;
  }
  .flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flexSpaceNull {
    display: flex;
    justify-content: space-between;
  }

  /* FONT SIZES */
  .font11 {
    font-size: 0.688rem;
  }
  .font12 {
    font-size: 0.75rem;
  }
  .font13 {
    font-size: 0.813rem;
  }
  .font14 {
    font-size: 0.875rem;
  }
  .font15 {
    font-size: 0.938rem;
  }
  .font18 {
    font-size: 1.125rem;
  }
  .font20 {
    font-size: 1.25rem;
  }
  .font25 {
    font-size: 1.563rem;
  }
  .font30 {
    font-size: 1.875rem;
  }
  .font40 {
    font-size: 2.5rem;
  }
  .font60 {
    font-size: 3.75rem;
    line-height: 4.5rem;
  }
  @media only screen and (max-width: 859px) {
    .font11 {
      font-size: 0.688rem;
    }
    .font12 {
      font-size: 0.688rem;
    }
    .font13 {
      font-size: 0.75rem;
    }
    .font14 {
      font-size: 0.813rem;
    }
    .font15 {
      font-size: 0.813rem;
    }
    .font18 {
      font-size: 0.938rem;
    }
    .font20 {
      font-size: 1.125rem;
    }
    .font25 {
      font-size: 1.25rem;
    }
    .font30 {
      font-size: 1.5rem;
    }
    .font40 {
      font-size: 1.875rem;
    }
    .font60 {
      font-size: 2.8rem;
    }
  }
  /* BORDER RADIUS */
  .radius8 {
    border-radius: 1rem;
  }
  .radius6 {
    border-radius: 0.6rem;
  }
  /* COLORS */
  .darkColor {
    color: #0B093B;
  }
  .purpleColor {
    color: #72246c;
  }
  .orangeColor {
    color: #F2B300;
  }
  .lightColor {
    color: #F5F5F5;
  }
  .coralColor {
    color: #C4FFFF;
  }
  .greenColor {
    color: #49CB86
  }
  .greyColor {
    color: #707070;
  }
  .whiteColor {
    color: #fff;
  }
  /* BACKGROUNDS */
  .darkBg {
    background-color: #0B093B;
  }
  .purpleBg {
    background-color: #72246c;
  }
  .orangeBg {
    background-color: #F2B300;
  }
  .lightBg {
    background-color: #F5F5F5;
  }
  .coralBg {
    background-color: #C4FFFF;
  }
  .greenBg {
    background-color: #49CB86;
  }
  .greyBg {
    background-color: #707070;
  }
  .whiteBg {
    background-color: #fff;
  }
`, "",{"version":3,"sources":["webpack://./src/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;IAaI,SAAS;IACT,UAAU;IACV,SAAS;IACT,wBAAwB;IACxB,sBAAsB;EACxB;EACA,gDAAgD;EAChD;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;;IAEE,WAAW;IACX,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,+BAA+B;IAC/B,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA,yBAC4C,kDAAkD;IAC5F,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;MACf,WAAW;MACX,SAAS;MACT,cAAc;IAChB;EACF;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA,aAAa;EACb;IACE;EACF;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,+CAA+C;IAC/C,uDAAuD;IACvD,oDAAoD;EACtD;EACA,YAAY;EACZ;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA,eAAe;EACf;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;EACF;EACA,kBAAkB;EAClB;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA,WAAW;EACX;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE;EACF;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA,gBAAgB;EAChB;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB","sourcesContent":["html, body, div, span, applet, object, iframe,\r\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\r\n  a, abbr, acronym, address, big, cite, code,\r\n  del, dfn, em, img, ins, kbd, q, s, samp,\r\n  small, strike, strong, sub, sup, tt, var,\r\n  b, u, i, center,\r\n  dl, dt, dd, ol, ul, li,\r\n  fieldset, form, label, legend,\r\n  table, caption, tbody, tfoot, thead, tr, th, td,\r\n  article, aside, canvas, details, embed, \r\n  figure, figcaption, footer, header, hgroup, \r\n  menu, nav, output, ruby, section, summary,\r\n  time, mark, audio, video {\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    vertical-align: baseline;\r\n    box-sizing: border-box;\r\n  }\r\n  /* HTML5 display-role reset for older browsers */\r\n  article, aside, details, figcaption, figure, \r\n  footer, header, hgroup, menu, nav, section {\r\n    display: block;\r\n  }\r\n  ol, ul {\r\n    list-style: none;\r\n  }\r\n  blockquote, q {\r\n    quotes: none;\r\n  }\r\n  blockquote:before, blockquote:after,\r\n  q:before, q:after {\r\n    content: '';\r\n    content: none;\r\n  }\r\n  table {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n  }\r\n  a {\r\n    text-decoration: none!important;\r\n    color: #0B093B;\r\n  }\r\n  a:hover {\r\n    color: #72246c;\r\n  }\r\n  input:-webkit-autofill {\r\n    -webkit-box-shadow:0 0 0 50px #fff inset; /* Change the color to your own background color */\r\n    box-shadow: transparent;\r\n    -webkit-text-fill-color: #fff;\r\n  }\r\n  body {\r\n    background: #fff;\r\n    color: #0B093B;\r\n    font-family: 'Khula', sans-serif;\r\n    overflow-x: hidden;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n  }\r\n  .container {\r\n    width: 100%;\r\n    max-width: 1220px;\r\n    margin: 0 auto;\r\n    padding: 0px 30px;\r\n  }\r\n  @media only screen and (max-width: 859px) {\r\n    .container {\r\n      max-width: 100%;\r\n      width: 100%;\r\n      margin: 0;\r\n      padding: 0 5px;\r\n    }\r\n  }\r\n  .regular {\r\n    font-weight: 400!important;\r\n  }\r\n  .semiBold {\r\n    font-weight: 600!important;\r\n  }\r\n  .extraBold {\r\n    font-weight: 800!important;\r\n  }\r\n\r\n  /* HELLPERS */\r\n  .textCenter {\r\n    text-align: center\r\n  }\r\n  .animate {\r\n    transition: 0.3s ease;\r\n  }\r\n  .pointer {\r\n    cursor: pointer;\r\n  }\r\n  .relative {\r\n    position: relative;\r\n  }\r\n  .textCenter {\r\n    text-align: center;\r\n  }\r\n  .textLeft {\r\n    text-align: left;\r\n  }\r\n  .textRight {\r\n    text-align: right;\r\n  }\r\n  .x100 {\r\n    width: 100%;\r\n  }\r\n  .active {\r\n    border-bottom: 2px solid #72246c;\r\n    color: #72246c;\r\n  }\r\n  .tag {\r\n    padding: 5px 10px;\r\n    margin: 10px 0;\r\n  }\r\n  .shadow {\r\n    box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; \r\n    -webkit-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; \r\n    -moz-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; \r\n  }\r\n  /* FLEXBOX */\r\n  .flex {\r\n    display: flex;\r\n  }\r\n  .flexSpaceCenter {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n  .flexNullCenter {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  .flexColumn {\r\n    flex-direction: column;\r\n  }\r\n  .flexCenter {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .flexSpaceNull {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  /* FONT SIZES */\r\n  .font11 {\r\n    font-size: 0.688rem;\r\n  }\r\n  .font12 {\r\n    font-size: 0.75rem;\r\n  }\r\n  .font13 {\r\n    font-size: 0.813rem;\r\n  }\r\n  .font14 {\r\n    font-size: 0.875rem;\r\n  }\r\n  .font15 {\r\n    font-size: 0.938rem;\r\n  }\r\n  .font18 {\r\n    font-size: 1.125rem;\r\n  }\r\n  .font20 {\r\n    font-size: 1.25rem;\r\n  }\r\n  .font25 {\r\n    font-size: 1.563rem;\r\n  }\r\n  .font30 {\r\n    font-size: 1.875rem;\r\n  }\r\n  .font40 {\r\n    font-size: 2.5rem;\r\n  }\r\n  .font60 {\r\n    font-size: 3.75rem;\r\n    line-height: 4.5rem;\r\n  }\r\n  @media only screen and (max-width: 859px) {\r\n    .font11 {\r\n      font-size: 0.688rem;\r\n    }\r\n    .font12 {\r\n      font-size: 0.688rem;\r\n    }\r\n    .font13 {\r\n      font-size: 0.75rem;\r\n    }\r\n    .font14 {\r\n      font-size: 0.813rem;\r\n    }\r\n    .font15 {\r\n      font-size: 0.813rem;\r\n    }\r\n    .font18 {\r\n      font-size: 0.938rem;\r\n    }\r\n    .font20 {\r\n      font-size: 1.125rem;\r\n    }\r\n    .font25 {\r\n      font-size: 1.25rem;\r\n    }\r\n    .font30 {\r\n      font-size: 1.5rem;\r\n    }\r\n    .font40 {\r\n      font-size: 1.875rem;\r\n    }\r\n    .font60 {\r\n      font-size: 2.8rem;\r\n    }\r\n  }\r\n  /* BORDER RADIUS */\r\n  .radius8 {\r\n    border-radius: 1rem;\r\n  }\r\n  .radius6 {\r\n    border-radius: 0.6rem;\r\n  }\r\n  /* COLORS */\r\n  .darkColor {\r\n    color: #0B093B;\r\n  }\r\n  .purpleColor {\r\n    color: #72246c;\r\n  }\r\n  .orangeColor {\r\n    color: #F2B300;\r\n  }\r\n  .lightColor {\r\n    color: #F5F5F5;\r\n  }\r\n  .coralColor {\r\n    color: #C4FFFF;\r\n  }\r\n  .greenColor {\r\n    color: #49CB86\r\n  }\r\n  .greyColor {\r\n    color: #707070;\r\n  }\r\n  .whiteColor {\r\n    color: #fff;\r\n  }\r\n  /* BACKGROUNDS */\r\n  .darkBg {\r\n    background-color: #0B093B;\r\n  }\r\n  .purpleBg {\r\n    background-color: #72246c;\r\n  }\r\n  .orangeBg {\r\n    background-color: #F2B300;\r\n  }\r\n  .lightBg {\r\n    background-color: #F5F5F5;\r\n  }\r\n  .coralBg {\r\n    background-color: #C4FFFF;\r\n  }\r\n  .greenBg {\r\n    background-color: #49CB86;\r\n  }\r\n  .greyBg {\r\n    background-color: #707070;\r\n  }\r\n  .whiteBg {\r\n    background-color: #fff;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
